import cn from "classnames";
import React from "react";

import { makeBEM } from "utils";

import "./index.scss";

export interface TypographyProps extends Omit<React.HTMLProps<HTMLElement>, "size"> {
  as?: keyof React.ReactHTML;
  uppercase?: boolean;
  /** Font weight */
  fw?: React.CSSProperties["fontWeight"];
  color?: string;
  noMargin?: boolean;
  size?: number | string;
  textDecoration?: React.CSSProperties["textDecoration"];
  align?: React.CSSProperties["textAlign"];
  nowrap?: boolean;
}

const bem = makeBEM("typography");

export const Typography = React.forwardRef<HTMLElement, TypographyProps>(
  (
    {
      as = "div",
      uppercase,
      color,
      fw,
      style,
      noMargin = true,
      className,
      size,
      textDecoration,
      align,
      nowrap,
      ...props
    },
    ref,
  ) => {
    return React.createElement(as, {
      ref,
      className: cn(
        className,
        bem(null, {
          uppercase,
          "no-margin": noMargin,
        }),
      ),
      style: {
        fontWeight: fw,
        color,
        fontSize: size,
        textDecoration,
        textAlign: align,
        whiteSpace: nowrap ? "nowrap" : undefined,
        ...style,
      },
      ...props,
    });
  },
);
